// extracted by mini-css-extract-plugin
export default {"tips":"tips___wza3Q","itemTips":"itemTips___KZvhv","operation":"operation___Xs3VD","optWrapper":"optWrapper___a5OjC"};